// Статусы заказа на стороне сайта: что считать «активным» и как из
// серверного символа сделать CSS-модификатор.

// Активные (текущие) заказы — ровно те же три статуса, что и у сервера в
// Client#current_orders (app/models/concerns/client_orders.rb) и в
// клиентском приложении: заказ виден клиенту как «в работе» от момента
// оформления до доставки.
export const ACTIVE_STATUS_SYMBOLS = ['waiting_approve', 'warehouse', 'waiting_delivery'];

export function isActiveOrder(order) {
  return !!order && ACTIVE_STATUS_SYMBOLS.indexOf(order.status_symbol) !== -1;
}

// Модификатор чипа статуса: .ng-order__status--{symbol}.
// В серверном справочнике статусов символ отказа — 'refued' (опечатка в
// OrderStatuses::STATUSES_FULL), а во всех темах написан '--refused',
// поэтому нормализуем здесь. Если символа нет — возвращаем '' и компонент
// просто не добавляет второй класс (кириллический класс из o.status —
// нельзя).
export function statusMod(order) {
  const symbol = (order && order.status_symbol) || '';
  if (!symbol) return '';
  return symbol === 'refued' ? 'refused' : symbol;
}

// Куда везём заказ: адрес доставки либо точка самовывоза.
export function orderAddressLine(order) {
  const o = order || {};
  if (o.delivery_type === 'delivery') {
    const addr = o.address || {};
    return addr.full_addr_with_city || addr.full_addr || '';
  }
  return o.delivery_pickup_point || '';
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/shared/orderStatus.js